import React, { useEffect, useState } from 'react';
import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
} from '@chakra-ui/react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { createAPIEndPoint } from 'config/api/api';
import { getUserData } from 'utils';
import toast from 'react-hot-toast';

const CategoryModal = ({
  isOpen,
  onClose,
  type = 'add',
  initialData,
  fetchAgain,
}) => {
  const userData = getUserData();
  const clinic_id = userData.clinic_id ?? null;
  console.log('CategoryModal ~ initialData:', initialData);

  const [loading, setLoading] = useState(false);

  const validationSchema = Yup.object().shape({
    category: Yup.string().required('Category is required'),
  });

  const handleCreate = async (values, { resetForm }) => {
    try {
      setLoading(true);
      if (initialData.id) {
        // Update existing patient
        await createAPIEndPoint('service_categories/').update(initialData.id, {
          ...values,
          clinic_id,
        });
      } else {
        // Create new patient
        await createAPIEndPoint('service_categories').create({
          ...values,
          clinic_id,
        });
      }
      toast.success('Category added successfully!');
      setLoading(false);
      resetForm();
      fetchAgain();
      onClose();
    } catch (error) {
      setLoading(false);
      console.error('Error creating category:', error);
      const errorMessage =
        error.response?.data?.error ||
        'An error occurred while creating the category.';
      toast.error(errorMessage);
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      category: initialData?.category || '',
    },
    validationSchema,
    onSubmit: handleCreate,
  });

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        onClose();
      }}
      isCentered
    >
      <ModalOverlay />
      <ModalContent
        borderRadius="16px"
        pb="16px"
        maxWidth={{ base: '90%', md: '448px' }}
        maxH="90vh"
        overflowY="auto"
      >
        <ModalHeader color="brand.500">
          {type === 'edit' ? 'Edit Category' : 'Add Category'}
        </ModalHeader>
        <ModalCloseButton />
          <form onSubmit={formik.handleSubmit}>
        <ModalBody maxHeight="70vh" overflowY="auto" pb={2}>
            {['category'].map((field, index) => (
              <FormControl
                key={index}
                isInvalid={formik.touched[field] && formik.errors[field]}
                mb={2}
              >
                <FormLabel mb={0} textTransform="capitalize">
                  {field.replace(/([A-Z])/g, ' $1').trim()}
                </FormLabel>
                <Input
                  name={field}
                  placeholder={`Enter ${field
                    .replace(/([A-Z])/g, ' $1')
                    .trim()
                    .toLowerCase()}`}
                  variant="auth"
                  fontSize="sm"
                  fontWeight="500"
                  value={formik.values[field]}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched[field] && formik.errors[field] && (
                  <Text color="red.500" fontSize="sm">
                    {formik.errors[field]}
                  </Text>
                )}
              </FormControl>
            ))}
        </ModalBody>
        <ModalFooter pt={0}>
          <Button type="submit" colorScheme="brand" w="100%" mt={4} isLoading={formik.isSubmitting}>
            {type === 'edit' ? 'Edit Category' : 'Add Category'}
          </Button>
        </ModalFooter>
          </form>
      </ModalContent>
    </Modal>
  );
};

export default CategoryModal;
